import { InputText as InputTexts } from 'primereact/inputtext';  

const InputText = ({...rest}) => {

    return (
        <InputTexts {...rest} />
    )

};

export default InputText;